module.exports = __webpack_public_path__ + "media/images/svg/logo_AVETID-6ec605ae695c86faa7898be99034fe7f.svg";